import {
  Activity,
  Parent,
  SearchFilters as SearchFiltersType
} from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";

import {
  getClassPageTitle,
  getDefaultPageDescription,
  getDefaultPageTitle,
  getOnlineClassesPageDescription,
  getOnlineClassesPageTitle,
  getParentPageDescription,
  getParentPageTitle,
  getSearchPageDescription,
  getSearchPageTitle
} from "../../shared/PageMetadata";

export function useClassPageTitle(
  activity: Pick<Activity, "age_max" | "age_min" | "isClub" | "title">
): string | null {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return getClassPageTitle(t, activity);
}

export const useDefaultPageTitle = (): string => {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return getDefaultPageTitle(t);
};

export const useDefaultPageDescription = () => {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return getDefaultPageDescription(t);
};

export function useOnlineClassesPageTitle(
  term: string = "",
  titleCaseInput: boolean = true
): string {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return getOnlineClassesPageTitle(t, term, titleCaseInput);
}

export function useOnlineClassesPageDescription(): string {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return getOnlineClassesPageDescription(t);
}

export function useSearchPageTitle(filters: SearchFiltersType): string {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return getSearchPageTitle(t, filters);
}

export function useSearchPageDescription(theme: string): string {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return getSearchPageDescription(t, theme);
}

export function useParentPageTitle(parent: Pick<Parent, "publicName">): string {
  return getParentPageTitle(parent);
}

export function useParentPageDescription(
  parent: Pick<Parent, "publicName" | "introduction">
): string {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return getParentPageDescription(t, parent);
}
